import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useRouter } from '@tanstack/react-router'
import { MAIN_PAGE_URL } from '../../../constants'

export const NotFound = () => {
    const { t } = useTranslation()
    const router = useRouter()
    return <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-4xl font-bold ">404</h1>
        <p className="text-2xl">{t('页面不存在')}</p>
        <Button className="mt-4" type="primary" onClick={() => router.history.push(MAIN_PAGE_URL)}>{t('返回主页')}</Button>
    </div>
}
